(() => {
  if (customElements.get("product-review-variants")) return;

  class ProductReviewVariants extends HTMLElement {
    constructor() {
      super();

      this.addVariantLines = this.addVariantLines.bind(this);
    }

    connectedCallback() {
      this.template = this.querySelector("[data-variant-template]");
      if (!this.template) return;

      this.observer = new MutationObserver(this.addVariantLines);
      this.observer.observe(this, { childList: true, subtree: true });
      this.addVariantLines();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    addVariantLines() {
      this.querySelectorAll(".jdgm-rev[data-product-title]:not([data-variant-line])").forEach((review) => {
        review.setAttribute("data-variant-line", "");

        // Product names follow "<Product> - <Color> <Size>", e.g. "Elixir Mixer 2 - Jet Black 24oz"
        const options = review.dataset.productTitle.split(" - ").slice(1).join(" - ").trim();
        const match = options.match(/^(.+?)\s+([\d.]+\s?oz)$/i);
        const content = review.querySelector(".jdgm-rev__content");
        if (!match || !content) return;

        const line = this.template.content.cloneNode(true);
        line.querySelector("[data-variant-color]").textContent = match[1];
        line.querySelector("[data-variant-size]").textContent = match[2];
        content.append(line);
      });
    }
  }

  customElements.define("product-review-variants", ProductReviewVariants);
})();
